import { render, staticRenderFns } from "./BasicPublications.vue?vue&type=template&id=6ed1ddac"
import script from "./BasicPublications.vue?vue&type=script&lang=js"
export * from "./BasicPublications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports